import { render, staticRenderFns } from "./EditPass.vue?vue&type=template&id=05c41ebd&scoped=true"
import script from "./EditPass.vue?vue&type=script&lang=js"
export * from "./EditPass.vue?vue&type=script&lang=js"
import style0 from "./EditPass.vue?vue&type=style&index=0&id=05c41ebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c41ebd",
  null
  
)

export default component.exports